import dashboard from './dashboard';
import inmuebles from './inmuebles';
import catalogos from './catalogos';
import buro from "./buro";
//import utilities from './utilities';
import administracion from "./administracion";
import statistics from './statistics';
import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    //items: [dashboard, pages, utilities, other]
    items: [dashboard, inmuebles, buro, catalogos, administracion, statistics, other]
};

export default menuItems;
